import { Component, OnInit, ViewEncapsulation, HostListener, Inject } from '@angular/core';
import { OvsComponent, Core, LabelNames, ApplicationConfiguration } from '../shared/core/ovs.core';
import { DOCUMENT } from "@angular/platform-browser";

@Component({
  selector: 'main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MainHeaderComponent extends OvsComponent  
{
    private _document: Document;

    public logoUrl: string;
    public myAccountHRef: string;
    public myAccountText: string;
    public phoneNumber: string;
    public logoNavigationUrl: string;
    public isMenuOpen: boolean = false;
    public isNavFixed: boolean;
    constructor(@Inject(DOCUMENT) document: Document)
    {
        super();
        this._document = document;
    }

    public initialize(): void
    {
    }

    public toggleMenu(): void
    {
        this.isMenuOpen = !this.isMenuOpen;
    }

    protected configurationChanged(): void
    {
        let config : ApplicationConfiguration = this.configuration;
        this.logoUrl = config.Logos ? config.Logos.first().ImageUrl : "";
        this.logoNavigationUrl = config.Logos ? config.Logos.first().NavigationUrl : "";
        this.myAccountHRef = config.Labels ? config.Labels.first(l => l.Name == LabelNames.MyAccountHRef).DisplayText : "---";
        this.myAccountText = config.Labels ? config.Labels.first(l => l.Name == LabelNames.AccountSettingsLabel).DisplayText : "---";
        this.phoneNumber = config.Partner ? config.Partner.PhoneNumber : "---"; 
    }

    @HostListener('window:scroll', [])
    public onWindowScroll()
    {
        const number = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        if (number > 150)
        {
            this.isNavFixed = true;
        } else if (this.isNavFixed && number < 10)
        {
            this.isNavFixed = false;
        }
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/header/main-header.component.ts